const DAYS = 1000 * 60 * 60 * 24;
const TOKEN_TIMEOUT = 1000 * 60 * 15;
const FULLNAME_PATTERN = /^\s?([a-zA-Z'-]+[,.]?[ ]+)+[a-zA-Z'-]{1,}\s?$/i;
const PHONE_PATTERN = /^(?:(?:\+?1\s*(?:[.-]\s*)?)?(?:\(\s*([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9])\s*\)|([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))\s*(?:[.-]\s*)?)?([2-9]1[02-9]|[2-9][02-9]1|[2-9][02-9]{2})\s*(?:[.-]\s*)?([0-9]{4})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?$/;
const PATHNAME = /#(.*?)(?:\?|$)/g; // e

var Constants = /*#__PURE__*/Object.freeze({
	__proto__: null,
	DAYS: DAYS,
	TOKEN_TIMEOUT: TOKEN_TIMEOUT,
	FULLNAME_PATTERN: FULLNAME_PATTERN,
	PHONE_PATTERN: PHONE_PATTERN,
	PATHNAME: PATHNAME
});

export { Constants as C, DAYS as D, FULLNAME_PATTERN as F, PHONE_PATTERN as P, TOKEN_TIMEOUT as T, PATHNAME as a };
//# sourceMappingURL=Constants-532d5e22.js.map
